import React, { Component } from "react";

import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import $ from "jquery";
import TipoOptionForm from "./TipoOptionForm";
import queryString from "query-string";
import services from "../../../services";
import { toast } from "react-toastify";
import { array } from "prop-types";


const Request = [
    "IDVasilha",
    "IDTipoVasilha",
    "NumeroVasilha",
    "IDInstalacaoVinica",
    "codEntidade",
    "Localizacao",
  
    "Observacoes",
    "CapacidadeComunicada",
    "CapacidadeCalculada",
    "Dimensao1",
    "Dimensao2",
    "Dimensao3",
    "Dimensao4",
    "Dimensao5",
];

const requiredFields = [
    "IDTipoVasilha", //
    "IDInstalacaoVinica",
    "NumeroVasilha",
    // "codEntidade",//
    //"Localizacao", //
    
    "CapacidadeComunicada",
    "CapacidadeCalculada", //
];
var vasilhaCalculo = []

class Inserirvasilha extends Component {
    constructor() {
        super();

        this.state = {
            result: "",
            tipoOptionValue: "",
            data: {},
            IDVasilha : "",
            NumeroVasilha: "",
            id: "",
            Obser:"",
           // calculationResult: "",
            tipoCurrent: "",
            Observacoes: "",
            idVasilha: 0,
            numparant: "",
            capacity: "",
            user: "",
            Localizacao: "",
            nifArray: [],
            vasilahDropdownData: [],
            requiredField: {
                numparant: false,
                // capacity: false,
                // Obser: false,
                // calculationResult: false,
                user: false,
                Localizacao: "",
            },
            isCalculationOk: true,
            row: {},
            codEntidade: "",
            
        };
    }

    componentDidMount() {

        let query = queryString.parse(window.location.search)

        this.setState({
            codEntidade: query.codEntidade,
        })

        console.log("the row is  ", this.props.row);
        $("#tipoVasilhas option[value='" + this.props.row.idTipoVasilha + "']").attr("selected","selected");
        // preenchimento da drop
        (async () => {

            var  dataToken = {}
            var Detalhes = await services.apiCall.requestApi(
                "/InstalacaoVinica/GetAllTipoVasilha",
                dataToken,
                "get"
            ); 
            
            var strHTML = "<option value='0' selected>Selecione...</option>";
            for (let index = 0; index < Detalhes.length; index++) {
              var TipoVasilha = Detalhes[index].tipoVasilha;
              var idTipoVasilha = Detalhes[index].idTipoVasilha;
              
            strHTML = strHTML + "<option value='" + idTipoVasilha + "'>" + TipoVasilha + "</option>";
            }

            $("#tipoVasilhas").html(strHTML)
            if (Object.keys(this.props.row).length > 0) {
                $("#tipoVasilhas option[value='" + this.props.row.idTipoVasilha + "']").attr("selected","selected");
            }
 
        })();

        if (Object.keys(this.props.row).length > 0) {
            
            //$("#tipoVasilhas"[this.props.row.tipoVasilha]).attr("selected",true)
            console.log("rowwww issss", this.props.row);
           
            this.setState(
                {
                    row: this.props.row,
                },
                () => {
                    this.setRowState(this.state.row);
                }
            );
        } else {
            this.setDefaulltState();
           // $("#tipoVasilhas option[value='" + 0 + "']").attr("selected","selected");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // (async () => {    

        //     var  dataToken1 = {IDInstalacaoVinica: this.props.IDInstalacaoVinica,
        //                        IDTipoVasilha: this.props.row.idTipoVasilha}
        //     var Detalhes1 = await services.apiCall.requestApi(
        //         "/Fiscalizacao/GetNVasilha",
        //         dataToken1,
        //         "get"
        //     );
            
        //     // var Obser = Detalhes1[0].observacoes;
        //     // $("#observacoes").val(Obser)
        //     // $("#observacoes").text(Obser)
   
        // })();
        console.log("the row is  ", this.props.row);
        if($("#capac").val() != this.props.row.capacidadeAferida){
            $(".k-textbox-container").removeClass("k-state-empty")
            $("#capac").val(this.props.row.capacidadeAferida)  
        }
        if($("#tipoVasilhas").val() != this.props.row.idTipoVasilha){
            $("#tipoVasilhas option[value='" + this.props.row.idTipoVasilha + "']").attr("selected","selected");
          
        }
        
        $("#tipoVasilhas option[value='" + this.props.row.idTipoVasilha + "']").attr("selected","selected");
        if (prevProps.date !== this.props.date) {
            if (Object.keys(this.props.row).length > 0) {
                console.log("rowwww issss", prevProps);
                // Preenchimento da drop
                $("#tipoVasilhas option[value='" + this.props.row.idTipoVasilha + "']").attr("selected","selected");
                

                this.setState(
                    {
                        row: this.props.row,
                    },
                    () => {
                        this.setRowState(this.state.row);
                    }
                );
            } else {
                this.setDefaulltState();
                $('#tipoVasilhas option').removeAttr("selected","selected");
                $("#tipoVasilhas option[value='" + 0 + "']").attr("selected","selected");
            }
        }

        if (prevState.isCalculationOk !== this.state.isCalculationOk) {
            if (this.state.isCalculationOk === false) {
                // this.setState({
                //     calculationResult: 0,
                // });
                if(this.props.row != undefined){
                    $(".k-textbox-container").removeClass("k-state-empty")
                    $("#capac").val(this.props.row.capacidadeAferida)
                }
            }
        }

        
    }

    getVasilahDropdown = () => {
        let { displayData } = this.props;
        if (displayData.Instalação.length === 0) {
            return displayData.Utilizadores;
        } else {
            let arr = displayData.Utilizadores.filter(
                (Util) => Util.nif != displayData.Instalação[0].nif
            );
            return [...arr, ...displayData.Instalação];
        }
    };

    setRowState = (row) => {
        this.setState(
            {
                user: row.codEntidade,
                Localizacao: row.localizacao,
                //numparant: row.matricula,
                capacity: row.capacidadeComunicada,
                Obser: row.observacoes,
                IDVasilha: row.idVasilha,
                //calculationResult: row.capacidadeCalculada,
            },
            () => {
                this.setTipoList(
                    this.state.row["tipoVasilha"]
                        ? this.state.row["tipoVasilha"].toString()
                        : null
                );
            }
        );
    };

    setDefaulltState = () => {
        this.setState({
            user: "",
            Localizacao: "",
            numparant: "",
            capacity: 0,
            Obser: "",
            IDVasilha: 0,
            tipoOptionValue: "",
           // calculationResult: 0,
            requiredFieldsToggle: false,
            tipoVasilha: "",
        });
    };

    // tipoCal=(e)=>{

    //      rend = async()=>{

    //             let obj =

    //          let res = await services.apiCall.requestApi("/allservice/TipoVasilha/GetAll",combolistrequest,"post")
    //     }
    //  }
    onClick = (button) => {
        if (button === "=") {
            this.calculate();
        } else if (button === "C") {
            this.reset();
        } else if (button === "CE") {
            this.backspace();
        } else {
            this.setState({
                result: this.state.result + button,
            });
        }
    };

    calculate = () => {
        try {
            this.setState({
                // eslint-disable-next-line
                result: (eval(this.state.result) || "") + "",
            });
        } catch (e) {
            this.setState({
                result: "error",
            });
        }

        
    };

    reset = () => {
        this.setState({
            result: "",
        });
    };

    checkFormatOfInput = (e) => {
        let checkIfNum = false;
        if (e.key !== undefined) {
            checkIfNum =
                e.key === "e" ||
                e.key === "+" ||
                e.key === "-" ||
                e.key === "E";
        } else if (e.keyCode !== undefined) {
            checkIfNum =
                e.keyCode === 69 || e.keyCode === 187 || e.keyCode === 189;
        }
        return checkIfNum && e.preventDefault();
    };

    backspace = () => {
        this.setState({
            result: this.state.result.slice(0, -1),
        });
    };
    capitaliseKey = (key, position) => {
        return (
            key.substr(0, position).toUpperCase() +
            key.substr(position, key.length)
        );
    };

    calFormValue = (data, option) => {
        console.log("Dados atuais recolhidos dos inputs:", data);
        console.log("Opção da vasilha:", option);
        // if(id!=this.state.id) this.state.capacity=0;
        this.setState({
            data,
            id: option,
            isCalculationOk: false,
        });
    };
    static getVasilhasCalculation = async (datavasilha) =>{
        if(datavasilha != undefined){vasilhaCalculo = datavasilha}
    }
    getCalculation = async () => {
        // let res = this.state.capacity
        var medida1 = $("#0").val() != undefined ? $("#0").val() : "-"
        var medida2 = $("#1").val() != undefined ? $("#1").val() : "-"
        var medida3 = $("#2").val() != undefined ? $("#2").val() : "-"
        var medida4 = $("#3").val() != undefined ? $("#3").val() : "-"
        var medida5 = $("#4").val() != undefined ? $("#4").val() : "-"
        var dataarray = []
        dataarray.push(medida1 ,medida2,  medida3 , medida4 , medida5)
       
        var { data, id } = { ...this.state } 
        data = dataarray 
        let newData = { TipoVasilha: id };
        let res = "";
        if(data != undefined && data != null){
            // if(vasilhaCalculo.length > 0){
            //     data = vasilhaCalculo
            // }
            Object.keys(data).map((key) => {
                //console.log("KEY: ", parseInt(key) + 1 )
                let idx = parseInt(key) + 1
                let preKey = "Medida" + idx; 
                let newKey = this.capitaliseKey(preKey, 1);
                let res = 0;
    
                if (!isNaN(+data[key])){
                    res = +data[key]
                }
    
                newData[newKey] = res;
            });
            
        //console.log('TipoCurrent value is.........    ', this.state.tipoCurrent)
        // if(this.state.tipoCurrent.)
            if (this.state.tipoCurrent.calculo !== "Capacidade") {
                newData["TipoVasilha"] = parseInt($("#tipoVasilhas :selected").val())
                res = await services.apiCall.requestApi(
                    "/InstalacaoVinica/GetVasilhaFormulaCalc",
                    newData,
                    "post"
                );
            } else res = this.state.capacity;
            console.log("my resssssssss", res);
            let { requiredField } = this.state;
            if (res) {
                requiredField["calculationResult"] = false;
                $(".k-textbox-container").removeClass("k-state-empty")
                $("#capac").val(res)
            }

            
        }
       

    };

    handleChange = (e) => {
        console.log("the option is.....", e.target.value);
        let name = e.target.name;
        let keyCode = e.nativeEvent.data;
        let checkvalue = e.target.value;

        let { requiredField } = this.state;
        if (Object.keys(requiredField).includes(name))
            requiredField[name] = false;

        if (checkvalue === "") {
            requiredField[name] = true;
        }

        console.log("CheckValue", name, checkvalue);
        let currData = "";
        if (name == "capacity") {
            if (isNaN(keyCode) == false || keyCode == ".") {
                let decimalsep = checkvalue.indexOf(".");
                if (decimalsep >= 1 && checkvalue.length <= 12) {
                    currData = checkvalue;
                } else if (decimalsep == -1 && checkvalue.length <= 12) {
                    currData = checkvalue;
                } else if (checkvalue.length > 12) {
                    return;
                }
            }

            this.setState({ [e.target.name]: currData });
        } else if (e.target.name == "Obser") {
            let { Obser } = this.state;
            Obser = e.target.value;
            this.setState({
                Obser,
            });
        
        } else if (e.target.name == "numeroVasilha") {
            let { NumeroVasilha } = this.state;
            NumeroVasilha = e.target.value;
            this.setState({
                NumeroVasilha,
            });
        
        } else {
            var idVas = parseInt($("#tipoVasilhas :selected").val())
            console.log(this.props)
            let tipoCurrentArr = this.props.tipoOptionList.filter((object) => {
                console.log(tipoCurrentArr , object , "ENCONTAR VASILHA")
                if (e.target.value == object.codTipoVasilha) {
                    return true;
                } else return false;
            });
            console.log("yes this is the one......", tipoCurrentArr);
            var idVas = $("#tipoVasilhas :selected").val()
            var TipoVas = $("#tipoVasilhas :selected").text()
            this.setState({
                [e.target.name]: e.target.value,
                tipoCurrent: tipoCurrentArr[0],
                //calculationResult: 0,
                idVasilha : idVas
            },
            () => {
                this.setTipoList(
                    TipoVas
                );
            });
        }
    };

    canclePopup = () => {
        ////console.log("OKOK");
        this.setState({
            forFilter: {},
            form: {},
        });
        $(".left-popup").trigger("click");
    };

    sortFunction = (list) => {
        if (Array.isArray(list) && list.length > 0) {
            return (
                //sort(){name:roll}{}
                list.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
            );
        }
    };

    updateTipoCurrent = (row) => {
        this.setState({
            tipoCurrent: row,
        });
    };

    insertVasilha = async () => {
        let Request = this.createRequestBody();
        let link;
        let isCreated = null;
        let { isValid, validCapacity } = this.checkMandatoryFields(Request);
        console.log("800 capacity", validCapacity);
        if (!isValid || !validCapacity) {
            toast.error("Existem campos obrigatórios por preencher");
            this.setState({
                requiredFieldsToggle: true,
            });
            return;
        }
        if (!this.state.IDVasilha) {
            link = "InstalacaoVinica/InsertVasilha";
            isCreated = true;
        } else {
            link = "InstalacaoVinica/UpdateVasilha";
            isCreated = false;
        }
        console.log("Reqquest", Request);
        let res = await services.apiCall.requestApi(link, Request, "post");
        if (res) {
            await this.props.getAllVasilha();
            this.props.closePopup();
            this.props.setStateDate();
            if (isCreated)
                toast.success("Vasilha associada à instalação vínica com sucesso!");
            else 
                toast.success("Vasilha editada com sucesso!");
        } else {
            toast.error("Não foi possível adicionar a vasilha");
            this.props.closePopup();
        }
    };

    checkMandatoryFields = (obj) => {
        console.log("Obj is 800", obj);
        let isValid = true;
        let validCapacity = false;
        requiredFields.map((key) => {
            if (key === "CapacidadeCalculada" || key === "CapacidadeComunicada") 
            {
                if (!!obj[key] && !validCapacity) {
                    validCapacity = true;
                }

            } else if (obj[key] === null) {
                isValid = false;
            }
        });
        return { isValid, validCapacity };
    };

    // preenchimento da drop
    setTipoList = (tipoVasilha) => {
        if (tipoVasilha === null) return;
        let tipoCurrentArr = this.props.tipoOptionList.filter((object) => {
            if (tipoVasilha == object.tipoVasilha) {
                return true;
            } else return false;
        });
        console.log("yes this is the one......", tipoCurrentArr);
        
        this.setState({
            ["tipoOptionValue"]: tipoVasilha,
            tipoCurrent: tipoCurrentArr[0],
            //calculationResult:0
        });
        TipoOptionForm.GetDimencoesCampos();
    };

    checkPaste = (e) => {
        const pasteData = e.clipboardData.getData('text');
        // Se o texto colado contiver "-" ou for um número menor que 0, bloqueia
        if (pasteData.includes('-') || parseFloat(pasteData) < 0) {
            e.preventDefault();
        }
    };
    


    createRequestBody = () => {
        let payLoad = {};

        Request.map((key) => {
            console.log("Teste: ",this.state)
            if (key === "IDVasilha") {
                payLoad[key] = this.state.IDVasilha || 0;
            } else if (key === "IDTipoVasilha") {
                payLoad[key] = parseInt($("#tipoVasilhas").val()) || null
            } else if (key === "codEntidade") {
                payLoad[key] = this.state.codEntidade || null;
            } else if (key === "IDInstalacaoVinica") {
                payLoad[key] = this.props.IDInstalacaoVinica || null;
            } else if (key === "Localizacao") {
                payLoad[key] = $("#Localizacao").val() || null;
            } else if (key === "NumeroVasilha") {
                payLoad[key] = $("#numeroVasilha").val() || null;
            }  else if (key === "Observacoes") {
                payLoad[key] = $("#Observacoes").val() || null;
            } else if (key === "CapacidadeComunicada") {
                payLoad[key] =
                    parseFloat(parseFloat(this.state.capacity)) || null;
            } else if (key === "CapacidadeCalculada") {
                payLoad[key] = parseFloat($("#capac").val()) || null;
            } else if (key === "Dimensao1") {
                payLoad[key] = $("#0").val() != "" && $("#0").val() != "-" && $("#0").val() != undefined
                    ? parseFloat($("#0").val())
                    : 0.0;
            } else if (key === "Dimensao2") {
                payLoad[key] =  $("#1").val() != "" && $("#1").val() != "-" && $("#1").val() != undefined
                ? parseFloat($("#1").val())
                : 0.0;
            } else if (key === "Dimensao3") {
                payLoad[key] = $("#2").val() != "" && $("#2").val() != "-" && $("#2").val() != undefined
                ? parseFloat($("#2").val())
                : 0.0;
            } else if (key === "Dimensao4") {
                payLoad[key] = $("#3").val() != "" && $("#3").val() != "-" && $("#3").val() != undefined
                ? parseFloat($("#3").val())
                : 0.0;
            } else if (key === "Dimensao5") {
                payLoad[key] = $("#4").val() != "" && $("#4").val() != "-" && $("#4").val() != undefined
                ? parseFloat($("#4").val())
                : 0.0;
            }
        });

        return payLoad;
    };

    handleSubmit = () => {
        this.insertVasilha();
    };

    /*  Para renderizar o conteúdo html da página   */

    render() {
        // console.log("propsfromWizard",this.props)
        let { tipoOptionList } = this.props;
        //codTipoVasilha
        console.log("Inserivisila Propped ", tipoOptionList);
        let params = queryString.parse(window.location.search);
        let id = params.id ? params.id : "";

        var idVas = parseInt($("#tipoVasilhas :selected").val())
        $("#tipoVasilhas option[value='" + idVas + "']").attr("selected","selected");
           
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span
                        className="modal-title bold"
                        style={{ fontSize: "large" }}
                    >
                        <b>{!id ? "Inserir vasilha" : "Detalhes da vasilha"}</b>
                    </span>
                    <Button
                        className="success btn-ivdp-primary l-350 mr-3"
                        primary={true}
                        onClick={() => this.handleSubmit()}
                    >
                        Gravar
                    </Button>
                    <Button
                        className="remoove k-primary btn-ivdp-secondary btn-theme ml-1 mr-2"
                        onClick={() => this.canclePopup()}
                    >
                        Cancelar
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="model-body">
                        {id ? (
                            <>
                                <div className="right-tab">
                                    <ul className="nav nav-tabs d-flex text-center">
                                        <li className="nav-item flex-fill">
                                            <a
                                                className="nav-link active  selos-nav right-tab"
                                                data-toggle="tab"
                                                href="#Detalhes"
                                            >
                                                Detalhes
                                            </a>
                                        </li>
                                        <li className="nav-item flex-fill">
                                            <a
                                                className="nav-link  selos-nav right-tab"
                                                data-toggle="tab"
                                                href="#Histórico"
                                            >
                                                Histórico
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane active container"
                                        id="Detalhes"
                                    >
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                <label className="mb-0">
                                                    <strong>Armazém</strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>Tipo</strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Tipo de material
                                                    </strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Capacidade Comunicada
                                                    </strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>número</strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <TipoOptionForm
                                                    viewFor={
                                                        this.state
                                                            .tipoOptionValue
                                                    }
                                                    id={id}
                                                    data={this.props.data || {}}
                                                    calFormValue={(
                                                        data,
                                                        option
                                                    ) =>
                                                        this.calFormValue(
                                                            data,
                                                            option
                                                        )
                                                    }
                                                    tipoOptionList={
                                                        tipoOptionList
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <div className="input-box active-grey">
                                                    <label className="input-label">
                                                        Observações
                                                    </label>
                                                    <textarea
                                                        className="form-control heigh-auto"
                                                        rows="3"
                                                        name="Obser"
                                                        id="observacoes"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane container"
                                        id="Histórico"
                                    >
                                        <div className="row mt-3">
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Capacidade Comunicada
                                                    </strong>
                                                </label>
                                                <p>Lorem Ipsum</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Data de comunicação
                                                    </strong>
                                                </label>
                                                <p>XX-XX-XXXX</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="row">
                                    {/* <div className="col-md-8"  style={{marginBottom:"-4px"}}>
                                        <div className="input-box active-grey drop-down-box">
                                            <label className="input-label">Entidade proprietária da vasilha</label>
                                            <select className="custome-drop-down" name="user" value={this.state.user} onChange={(e)=>this.handleChange(e)} placeholder="select value">
                                            <option disabled></option>
                                            {
                                                this.getVasilahDropdown().map((option,index)=>(
                                                  <option key={index} value={option.codEntidade}>{option.nome}</option>  
                                                ))
                                            }
                                            </select>
                                            {
                                                this.state.requiredFieldsToggle && 
                                                !this.state.user &&
                                                <span className="text-danger">Campo obrigatório</span>
                                            }
                                        </div>
                                    </div> */}
                                </div>
                                {/* <div className="row">
                                    <div
                                        className="col-md-8 "
                                        style={{ marginBottom: "-4px" }}
                                    >
                                        <div className="input-box active-grey drop-down-box">
                                            <Input
                                                style={{ width: "100%" }}
                                                onChange={(e) =>
                                                    this.handleChange(e)
                                                }
                                                value={this.state.Localizacao}
                                                type="text"
                                                name="Localizacao"
                                                className="input-1"
                                                label="Local"
                                                id="Localizacao"
                                            />
                                            {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                </div> */}
                                <div className="row align-items-center">
                                    <div className="col-md-4 mb-3">
                                        <div className="input-box active-grey">
                                            <Input
                                                style={{ width: "100%" }}
                                                className="input-1"
                                                name="numeroVasilha"
                                                type="text"
                                                label="Número"
                                                id="numeroVasilha"
                                                onChange={(e) =>
                                                    this.handleChange(e)
                                                }
                                                value={
                                                    this.state.NumeroVasilha == "" ? this.props.row.numeroVasilha : this.state.NumeroVasilha
                                                }
                                            />
                                            {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <div className="input-box active-grey">
                                            <Input
                                                style={{ width: "100%" }}
                                                className="input-1"
                                                name="capacity"
                                                value={
                                                    parseFloat(this.state.capacity)
                                                }
                                                type="number"
                                                step="0.00000000001"
                                                label="Capacidade Comunicada (L)"
                                                onChange={(e) =>
                                                    this.handleChange(e)
                                                }
                                                onPaste={(e) => this.checkPaste(e)}
                                            />
                                            {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )}
                                        </div>
                                    </div>

                                    {/*The dropdown not required---------------------*/}
                                    {/* <div className="col-md-12 mb-3">
                                        <div className="input-box active-grey drop-down-box">
                                            <label className="input-label">Armazém </label>
                                            <select className="custome-drop-down" onChange={(e) => this.handleChange(e)}  >
                                                <option>Selecione Armazém</option>

                                            </select>
                                        </div>
                                    </div> */}

                                    <div className="col-md-12">
                                        <div className="input-box active-grey drop-down-box">
                                            <label className="input-label">
                                                Tipo{" "}
                                            </label>
                                            <select class='custome-drop-down tipoVasilhas' name='tipoVasilhas' id="tipoVasilhas" onChange={(e) =>this.handleChange(e)} >
                                                    <option value='0'  selected disabled>Selecione...</option>
                                            </select>

                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-12 mb-3"
                                        style={{ top: "-5px" }}
                                    >
                                        {Array.isArray(tipoOptionList) && tipoOptionList.map((_option, i) => {
                                            if (
                                                _option && 
                                                _option.tipoVasilha && 
                                                this.state && 
                                                this.state.tipoOptionValue && 
                                                String(_option.tipoVasilha).trim() === String(this.state.tipoOptionValue).trim()
                                            ) {
                                                return (
                                                    <TipoOptionForm
                                                        data={this.props.row || {}}
                                                        key={i}
                                                        viewFor={this.state.tipoOptionValue}
                                                        row={_option}
                                                        calFormValue={(data, option) =>
                                                            this.calFormValue(
                                                                data,
                                                                option
                                                            )
                                                        }
                                                    />
                                                );
                                            }
                                            return null;
                                        })}
                                    </div>

                                    {/* <div className="col-sm-12 col-xl-6">
                                            <label className="input-label"> User</label>
                                            <select  className="custome-drop-down">
                                                <option>select option</option>
                                            </select>
                                        </div> */}

                                    <div
                                        className="col-md-6 mb-3"
                                        style={{ top: "-27px" }}
                                    >
                                        <div className="input-box active-grey">
                                            <Input
                                                style={{ width: "100%" }}
                                                min={0}
                                                className="input-1"
                                                name="capac"
                                                id="capac"
                                                label="Capacidade (L)"
                                                type="number"
                                                onPaste={(e) => this.checkPaste(e)}
                                            />
                                            {/* {this.state.requiredField
                                                .calculationResult && (
                                                <span className="text-danger">
                                                    Campo obrigatório
                                                </span>
                                            )} */}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-6 mb-3"
                                        style={{ top: "-27px" }}
                                    >
                                        <Button
                                            className="btn-ivdp-primary"
                                            onClick={() =>
                                                this.getCalculation()
                                            }
                                            primary={true}
                                        >
                                            Calcular
                                        </Button>
                                    </div>
                                    <div
                                        className="col-md-12 mb-3"
                                        style={{ top: "-27px" }}
                                    >
                                        <div className="input-box active-grey">
                                            <label className="input-label">
                                                Observações
                                            </label>
                                            <textarea
                                                className="form-control heigh-auto"
                                                rows="3"
                                                name="Observacoes"
                                                id="Observacoes"
                                                value={
                                                    this.state.Observacoes == "" ? this.props.row.observacoes : this.state.Observacoes
                                                }
                                                // onChange={(e) =>
                                                //     this.handleChange(e)
                                                // }
                                            ></textarea>
                                            {this.state.requiredField.Obser && (
                                                <span className="text-danger">
                                                    Campo obrigatório
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Inserirvasilha;
